import { Alert, IAlert, AlertCategory } from '.';

export const StaffAlertResolutions = [
    'Staff personally confirmed their safety',
    'Staff confirmed as safe by other parties',
    'Staff alert dealt with by emergency services',
    'Staff alert raised in error',
    'Staff alert otherwise dealt with',
] as const;

type AlertMessage = {
    message: string;
    timestamp: string;
};

interface IStaffAlert extends IAlert {
    messages: AlertMessage[];
    originPhoneNumber: string;
    resolution?: typeof StaffAlertResolutions[number];
    userId: string | null;
    lastKnownLocation: {
        latitude: number | null;
        longitude: number | null;
        dateTime: string | null;
    };
    organisation: string;
}

interface StaffAlert extends IStaffAlert {}

class StaffAlert extends Alert {
    category = AlertCategory.STAFF;

    constructor(data: IStaffAlert) {
        super(data);
        Object.assign(this, data);
    }

    get rawMessage(): string {
        return this.messages.map(({ message }) => message).join('\n\n');
    }
}

export { StaffAlert, IStaffAlert };
